import { FC, useMemo } from "react";
import { Button } from "@radix-ui/themes";
import { ColumnDef } from "@tanstack/react-table";
import { Table } from "@/components/table/table";
import { SpaceAccountAppCalloutSummarySchema } from "@/domains/openapi/types";
import { orderBy } from "lodash-es";
import { DateTime } from "luxon";
import { UuidFieldRow } from "@/components/table/uuid-field-row";
import { DateTimeFieldRow } from "@/components/table/datetime-field-row";

interface SpaceAccountAppCalloutsTableProps {
  data: SpaceAccountAppCalloutSummarySchema[];
  onViewSpaceAccountAppCallout: (id: string) => void;
  pageSize: number;
}

export const SpaceAccountAppCalloutsTable: FC<SpaceAccountAppCalloutsTableProps> = ({
  data,
  onViewSpaceAccountAppCallout,
  pageSize,
}) => {
  const columns = useMemo<ColumnDef<SpaceAccountAppCalloutSummarySchema>[]>(
    () => [
      {
        header: "ID",
        cell: ({ row }) => <UuidFieldRow id={row.original.id} />,
      },
      {
        header: "Internal Created At",
        cell: ({ row }) => <DateTimeFieldRow dateStr={row.original.internal_created_at} />,
      },
      {
        header: "Dismissed At",
        cell: ({ row }) => <DateTimeFieldRow dateStr={row.original.dismissed_at} />,
      },
      {
        header: "View",
        cell: ({ row }) => (
          <Button
            variant="outline"
            size="1"
            onClick={() => onViewSpaceAccountAppCallout(row.original.id)}
          >
            View
          </Button>
        ),
      },
    ],
    [onViewSpaceAccountAppCallout]
  );

  const orderedData = useMemo(
    () =>
      orderBy(
        data,
        x =>
          x.internal_created_at ? DateTime.fromISO(x.internal_created_at).toMillis() : -Infinity,
        "desc"
      ),
    [data]
  );
  return <Table data={orderedData} columns={columns} pageSize={pageSize} />;
};
